import React, { Fragment, lazy } from "react";
import { DownOutlined, InfoCircleOutlined, QuestionCircleOutlined, RightOutlined } from '@ant-design/icons';
import { Collapse, Input, Select, Checkbox, Tooltip, Switch } from 'antd';
import { numberCheck } from "../../../../services/helper/dataProcess";
import './setupInputGroup.css'

const SELECT = 'select', INPUT = 'input', INPUTANDSELECT = 'inputAndSelect', CHECKBOX = 'checkbox', SWITCH = "switch", ADVANCE = 'advance';

/**
 * type: select/input/selectAndInput/inputAndSelect
 * header: string
 * dataList: [{
 * label,
 * labelWidth,
 * value,
 * eleName: The name of the element, used for the callback of onChange
 * type: Enter the type of the tool，select/input/selectAndInput/inputAndSelect/checkbox/switch/advance,
 * [unit]
 * [options]: <Select /> The options attribute is required when the type is select
 * [suffixOptions]: The option of the suffix, by default, is the option of unit
 * [eleType]: The type of the element is defaulted to string, and number is the numeric type
 * [selectMode]: The mode attribute of <Select/>, multiple represents multiple selection, and tag represents label mode
 * [checkError]: Function, The check function returns error as the error message; otherwise, it is null
 * [disabled]: If the Account is Disabled
 * [maxTagCount]: The maxTagCount attribute of <Select/>
 * [maxTagPlaceholder]: The maxTagPlaceholder attribute of <Select/>
 * }]
 */
class SetupInputGroup extends React.Component {
  render = () => {
    const { header, children, collapseClassName, contentClassName, onChange, childrenPosition = "before" } = this.props;

    return <Collapse
      className={`ami-model-collapse-content jitter-collapse-content ${collapseClassName}`}
      items={[{
        key: { header },
        label: <div className="ami-model-jitter-title">{header}</div>,
        children: <>
          {childrenPosition === 'before' ? children : null}
          <SetupInputGroupItem dataList={this.props.dataList} contentClassName={contentClassName} onChange={onChange} />
          {childrenPosition === 'after' ? children : null}
        </>
      }]} />
  }
}

export default SetupInputGroup;

const EyePlotConfig = lazy(() => import("../../SimulationContent/components/EyePlotConfig"));
export class SetupInputGroupItem extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      currentInput: {
        item: {},
        value: null,
      },
      openAdvances: (props.dataList || []).filter(item => item.type === ADVANCE).map(item => item.label) || [],
      error: {
        eleName: "",
        info: ""
      }
    }
  }

  // input
  onChangeCurrentInput = (item, value) => {
    this.setState({
      currentInput: {
        item,
        value
      }
    })
  }

  onInputBlur = (e) => {
    const { currentInput: { item, value } } = this.state;
    let _value = value;
    let error = numberCheck(value, true);
    if (!error && typeof item.checkError === 'function') {
      error = item.checkError(value);
    }

    if (error) {
      e && e.target && e.target.focus();
      this.setState({ error: { eleName: item.eleName, info: error }, currentInput: { item, value } });
      return;
    }

    this.setState({ currentInput: { item: {}, value: null }, error: { eleName: "", info: "" } });

    if (item.unit) {
      _value = value + ' ' + item.unit;
    } else if (item.eleType === 'number') {
      _value = Number(_value);
    }
    this.props.onChange(item.eleName, _value);
  }

  // select unit
  onSelectSuffixChange = (item, suffix) => {
    const value = item.value + " " + suffix;
    this.props.onChange(item.eleName, value)
  }

  // select
  onSelectChange = (item, value) => {
    let _value = value;
    if (item.eleType === 'number') {
      _value = Number(_value);
    }
    this.props.onChange(item.eleName, _value);
  }

  onSimpleChange = (item, value) => {
    this.props.onChange(item.eleName, value)
  }

  onExpandAdvance = (label) => {
    const { openAdvances } = this.state;
    this.setState({ openAdvances: openAdvances.includes(label) ? openAdvances.filter(it => it !== label) : [...openAdvances, label] })
  }

  getInputAndSelectRender = (item = {}) => {
    const { currentInput: { item: currentItem, value: currentValue } } = this.state;
    const selectAfter = <Select
      value={item.unit}
      className="aurora-select setup-input-group-select-item"
      classNames={{ popup: { root: 'setup-input-group-select-item-dropdown' } }}
      onChange={(suffix) => this.onSelectSuffixChange(item, suffix)}
      disabled={item.disabled}
      options={item.suffixOptions || [{ value: 'null', label: 'null' }]}
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
    />
    return <Input
      style={{ width: `calc(100% - ${item.labelWidth || 220}px)` }}
      value={currentItem && currentItem.eleName === item.eleName ? currentValue : item.value}
      className="aurora-input"
      onChange={(e) => this.onChangeCurrentInput(item, e.target.value)}
      onFocus={() => this.onChangeCurrentInput(item, item.value)}
      onBlur={(e) => this.onInputBlur(e)}
      onPressEnter={(e) => e && e.target && e.target.blur()}
      disabled={item.disabled}
      addonAfter={selectAfter}
    />
  }

  getSelectRender = (item = {}) => {
    return <div style={{ width: `calc(100% - ${item.labelWidth || 220}px)` }}>
      <Select
        mode={item.selectMode || undefined}
        value={item.value}
        className={`aurora-select ${item.notExist ? "setup-select-width-not-exist" : "setup-select-width"}`}
        classNames={{ popup: { root: 'setup-input-group-select-item-dropdown' } }}
        onChange={(value) => this.onSelectChange(item, value)}
        disabled={item.disabled}
        allowClear={item.allowClear}
        options={item.options || []}
        maxTagCount={item.maxTagCount}
        maxTagPlaceholder={item.maxTagPlaceholder}
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
      />
    </div>
  }

  getInputRender = (item = {}) => {
    const { currentInput: { item: currentItem, value: currentValue } } = this.state;
    return <div style={{ width: `calc(100% - ${item.labelWidth || 220}px)` }}>
      <Input
        value={currentItem && currentItem.eleName === item.eleName ? currentValue : item.value}
        className="aurora-input"
        addonAfter={item.unit}
        onChange={(e) => this.onChangeCurrentInput(item, e.target.value)}
        onFocus={() => this.onChangeCurrentInput(item, item.value)}
        onBlur={(e) => this.onInputBlur(e)}
        onPressEnter={(e) => e && e.target && e.target.blur()}
        disabled={item.disabled}
      />
    </div>;
  }

  getCheckoutRender = (item = {}) => {
    return <Checkbox
      checked={item.value}
      style={{ width: `calc(100% - ${item.labelWidth || 220}px)` }}
      onChange={(e) => this.onSimpleChange(item, e.target.checked)}
      disabled={item.disabled}
    />
  }

  getSwitchRender = (item = {}) => {
    return <div style={{ width: `calc(100% - ${item.labelWidth || 220}px)` }}>
      <Switch
        checked={item.value}
        onChange={(checked) => this.onSimpleChange(item, checked)}
        disabled={item.disabled}
        size="small"
      />
    </div>
  }

  getItemRender = (item = {}, error) => {
    const isError = error.eleName === item.eleName && !!error.info;
    if (item.type === "EyePlotConfig") {
      return <EyePlotConfig
        eyePlotConfig={item.eyePlotConfig}
        onChange={this.props.onChange}
      />
    }
    return <div className="setup-input-group-flex-box">
      <label>
        {item.label}
        {item.tooltip ? <Tooltip title={item.tooltip} classNames={{ root: 'icon-tooltip setup-input-group-tooltip' }}>
          <InfoCircleOutlined className="setup-info-circle-icon" />
        </Tooltip> : null}
      </label>
      <Tooltip
        title={error.info}
        open={isError}
        classNames={{ root: "andes-v2-tooltip-error" }}
        destroyOnHidden
      >
        {item.type === INPUT ? this.getInputRender(item)
          : item.type === SELECT ? this.getSelectRender(item)
            : item.type === INPUTANDSELECT ? this.getInputAndSelectRender(item)
              : item.type === CHECKBOX ? this.getCheckoutRender(item)
                : item.type === SWITCH ? this.getSwitchRender(item)
                  : null}
      </Tooltip>
      {item.notExist ? <Tooltip
        title="The file was not found, please choose again."
        classNames={{ root: "aurora-tooltip" }}
      >
        <QuestionCircleOutlined className="setup-question-circle-icon" />
      </Tooltip> : null}
    </div>
  }

  render() {
    const { openAdvances, error } = this.state;
    const { contentClassName } = this.props;
    const dataList = this.props.dataList || [];
    return <div className={`setup-input-group-flex-container ${contentClassName}`}>
      {dataList.map(item => {
        return <Fragment key={item.label}>
          {
            item.type === ADVANCE
              ? <>
                <div className="setup-input-group-flex-box" key={item.label}>
                  <label>
                    {openAdvances.includes(item.label)
                      ? <DownOutlined className="setup-expand-icon" onClick={() => this.onExpandAdvance(item.label)} />
                      : <RightOutlined className="setup-expand-icon" onClick={() => this.onExpandAdvance(item.label)} />}
                    {item.label}
                  </label>
                </div>
                <div className="setup-advance-content">
                  {openAdvances.includes(item.label) ?
                    item.children.map(child => <Fragment key={child.label}>{this.getItemRender(child, error)}</Fragment>)
                    : null}
                </div>
              </>
              : this.getItemRender(item, error)
          }
        </Fragment>
      })}
    </div>
  }
}

export {
  SELECT,
  INPUT,
  INPUTANDSELECT,
  CHECKBOX,
  SWITCH,
  ADVANCE
}